<template>
  <div>
    <c-row>
      <c-col col="12">
        <loader v-show="loading"/>
        <c-card>
          <c-card-header>
            <strong>Barcode</strong>
            <div class="card-header-actions">
              <CInput
                @keyup="doSearch"
                type="text"
                placeholder="Ketikan sesuatu kemudian tekan enter"
                v-model="q"
                style="width: 400px"
                ref="search"
              ></CInput>
            </div>
          </c-card-header>
          <c-card-body style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th width="50px">No</th>
                  <th>Sumber</th>
                  <th>Petugas</th>
                  <th>Total Item</th>
                  <th>Tanggal Dibuat</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data" :key="k">
                  <td class="center">
                    <table-number
                      :size="dataSize"
                      :page="currentPage"
                      :index="k"
                    />
                  </td>
                  <td>{{ d.faktur }}</td>
                  <td>{{ d.user_name }}</td>
                  <td align="right">{{ d.qty }}</td>
                  <td align="right">{{ d.created_at | dateTimeFormat }}</td>
                  <td align="center">
                    <CButton
                      class="btn-outline-info btn btn-action"
                      v-c-tooltip.hover.click="'Print'"
                      @click="printWarranty(d.id)"
                    >
                      <i class="cil-print"></i>
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
          <c-card-footer>
            <CPagination
              align="end"
              :active-page.sync="currentPage"
              :pages="Math.ceil(total / dataSize)"
              responsive
            />
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue';
import TableNumber from "../../components/TableNumber";
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from "../../lib/httplib";

export default {
  name: "CardList",
  components: {
    TableNumber,
    Loader,
  },
  data() {
    return {
      loading: true,
      currentPage: 1,
      total: 1,
      data: [],
      q: "",
      dataUrl: "/api/v1/warranty",
      dataSize: 10,
      HTTPAPI: process.env.VUE_APP_API_HOST
    };
  },
  created() {
    const query = this.$route.query;
    if (query.q) {
      this.loadData(1, query.q);
      this.q = query.q;
      return;
    }
    this.loadData(1, "");
  },
  methods: {
    loadData(page, q) {
      this.loading = true
      this.currentPage = page;
      HTTPAUTH.get(
        this.dataUrl + `?q=${q}&page=${page}&size=${this.dataSize}`
      ).then((res) => {
        const paginate = res.data.paginate;
        this.total = paginate.total;
        this.data = res.data.data;
        this.loading = false
      }).catch(eres => {
        this.loading = false
        showErrorMessage(eres)
      });
    },
    doSearch(e) {
      if (e.keyCode === 13) {
        this.loadData(1, this.q);
        this.$router.push({ query: { search: true, q: this.q } });
      }
    },
    printWarranty(id) {
      window.open(
        `${this.HTTPAPI}/api/v1/warranty/barcode/view/${id}`,
        "_blank"
      );
    },
  },
  watch: {
    currentPage(pageNext) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.loadData(pageNext, q);
    },
  },
};
</script>